import { strings } from './strings';

export const displayName = (person: {
  firstName?: string;
  lastName?: string;
}) => {
  if (strings.getLanguage() === 'ja') {
    if (person.lastName && person.firstName) {
      return `${person.lastName} ${person.firstName}`;
    } else if (person.firstName) {
      return person.firstName;
    }
  }

  if (person.firstName && person.lastName) {
    return `${person.firstName} ${person.lastName}`;
  }
  return person.firstName ?? '';
};

export const displayInitials = (person: {
  firstName?: string;
  lastName?: string;
}) => {
  const getInitial = (name?: string) => (name ? name.charAt(0) : '');

  if (strings.getLanguage() === 'ja') {
    if (person.lastName && person.firstName) {
      return `${getInitial(person.lastName)}${getInitial(person.firstName)}`;
    } else if (person.firstName) {
      return getInitial(person.firstName);
    }
  }

  if (person.firstName && person.lastName) {
    return `${getInitial(person.firstName)}${getInitial(person.lastName)}`;
  }
  return getInitial(person.firstName);
};
